"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Use Infinite Scroll',
  description: "Choose Whether you want to have infinite scroll option or not. When this option is set to false the gallery will have\n  a \"Load More\". Note that the consumer will have to add the new items when the gallery requests more (\"NEED_MORE_ITEMS\" event will be emited).",
  isRelevant: function isRelevant(styleParams) {
    return !styleParams.oneRow;
  },
  type: _constants.INPUT_TYPES.BOOLEAN,
  "default": true
};
exports["default"] = _default;